import { render, staticRenderFns } from "./view-student.vue?vue&type=template&id=32211c72&scoped=true&"
import script from "./view-student.vue?vue&type=script&lang=js&"
export * from "./view-student.vue?vue&type=script&lang=js&"
import style0 from "./view-student.vue?vue&type=style&index=0&id=32211c72&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32211c72",
  null
  
)

export default component.exports